import { css } from '@emotion/core';

import { SPACE_COMPACT, grid, TABLET_BREAKPOINT, DESKTOP_BREAKPOINT, flexCenter } from '@/styles';

import { MINI_CARD_HEIGHT } from '../../slo-card/styles';

export const miniSlosGrid = [
  grid,
  css`
    min-height: ${MINI_CARD_HEIGHT}px;
    gap: ${SPACE_COMPACT}px;
    grid-template-columns: repeat(2, 1fr);

    @media screen and (max-width: ${TABLET_BREAKPOINT}px) {
      grid-template-columns: 1fr;
    }

    @media screen and (min-width: ${DESKTOP_BREAKPOINT}px) {
      grid-template-columns: repeat(3, 1fr);
    }
  `,
];

export const miniSlosGridEmpty = css`
  ${flexCenter}
  font-size: 14px;
  font-weight: 500;
`;

export const miniSlosStyle = css`
  padding: 0 ${SPACE_COMPACT}px ${SPACE_COMPACT}px;
`;

export const sloCardsGridExtendingStyles = css`
  grid-template-columns: none !important;
`;

export const sloCardsGridLoadingStyles = css`
  margin-left: ${SPACE_COMPACT}px;
`;
